var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSenseLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 122,
    height: 30,
    viewBox: "0 0 371.39 91.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".sense-logo-cls-1{isolation:isolate;}.sense-logo-cls-2{fill:#113;}.sense-logo-cls-3{fill:#ffd252;}.sense-logo-cls-4{fill:#f05a28;}.sense-logo-cls-5{fill:#7461e5;}.sense-logo-cls-6{fill:#33a30f;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "sense-logo-cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "sense-logo-cls-2",
    d: "M123.69,65.49c3.5,0,6-.4,7.6-1.3a4.44,4.44,0,0,0,2.4-4.3,5.6,5.6,0,0,0-2.6-4.7,36.8,36.8,0,0,0-8.4-4,69,69,0,0,1-6.6-2.8,24.6,24.6,0,0,1-5.2-3.4,13.2,13.2,0,0,1-3.4-4.7,17.17,17.17,0,0,1-1.3-6.8c0-5.2,1.9-9.4,5.8-12.4s9.1-4.5,15.7-4.5a50.41,50.41,0,0,1,9.6.9,43.8,43.8,0,0,1,6.9,1.8L141.79,30a26.37,26.37,0,0,0-5.6-1.8,36.69,36.69,0,0,0-7.8-.8,13.34,13.34,0,0,0-6.5,1.4,4.41,4.41,0,0,0-2.5,4.2,6.55,6.55,0,0,0,.5,2.5,5.21,5.21,0,0,0,1.7,2,27,27,0,0,0,3.2,1.9,40,40,0,0,0,4.8,1.9c3.1,1.2,5.8,2.3,8,3.4a20.66,20.66,0,0,1,5.4,3.8,12.41,12.41,0,0,1,3.1,4.8,18.13,18.13,0,0,1,1,6.5c0,5.5-2,9.6-6,12.4s-9.8,4.2-17.3,4.2a44.63,44.63,0,0,1-12.1-1.3,51.09,51.09,0,0,1-6.4-2l2.3-11a57.54,57.54,0,0,0,7,2.3A30.64,30.64,0,0,0,123.69,65.49Z",
    transform: "translate(-3.21 -2.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "sense-logo-cls-2",
    d: "M153.89,46.79a35.82,35.82,0,0,1,2.2-13.2,28.47,28.47,0,0,1,5.9-9.4,25.44,25.44,0,0,1,8.5-5.7,25.88,25.88,0,0,1,9.8-1.9c7.8,0,14,2.4,18.4,7.3s6.6,12.1,6.6,21.8a23.55,23.55,0,0,1-.1,2.5,19.48,19.48,0,0,1-.2,2.5h-37.6c.4,4.6,2,8.1,4.9,10.6s7,3.8,12.5,3.8a40.33,40.33,0,0,0,8.8-.9,34.52,34.52,0,0,0,6.3-1.9l1.7,10.8a16.23,16.23,0,0,1-3,1.1,35.25,35.25,0,0,1-4.4,1.1c-1.6.3-3.4.6-5.3.8a54.9,54.9,0,0,1-5.8.3,34.91,34.91,0,0,1-13.1-2.2,25.32,25.32,0,0,1-9.2-6.2,25,25,0,0,1-5.3-9.4A43.71,43.71,0,0,1,153.89,46.79Zm38.2-5.9a18.21,18.21,0,0,0-.8-5.2,14.54,14.54,0,0,0-2.2-4.3,11,11,0,0,0-3.6-2.8,11.32,11.32,0,0,0-5.1-1,12.53,12.53,0,0,0-5.3,1.1,14.49,14.49,0,0,0-3.9,3,13.14,13.14,0,0,0-2.5,4.3,20.65,20.65,0,0,0-1.2,4.9Z",
    transform: "translate(-3.21 -2.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "sense-logo-cls-2",
    d: "M217.09,19.79q3.75-1,9.9-2.1a80.68,80.68,0,0,1,13.5-1,31.18,31.18,0,0,1,11.7,1.9,19.93,19.93,0,0,1,7.5,5.3,19.35,19.35,0,0,1,3.9,8.3,44.24,44.24,0,0,1,1.1,10.6v32h-13.2v-30a43.39,43.39,0,0,0-.6-7.8,13.79,13.79,0,0,0-2-5.2,7.68,7.68,0,0,0-3.7-2.9,16.24,16.24,0,0,0-5.7-.9,46.66,46.66,0,0,0-5.2.3c-1.8.2-3.2.4-4,.5v46h-13.2Z",
    transform: "translate(-3.21 -2.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "sense-logo-cls-2",
    d: "M293,65.49c3.5,0,6-.4,7.6-1.3a4.44,4.44,0,0,0,2.4-4.3,5.6,5.6,0,0,0-2.6-4.7,36.8,36.8,0,0,0-8.4-4,69,69,0,0,1-6.6-2.8,24.6,24.6,0,0,1-5.2-3.4,13.2,13.2,0,0,1-3.4-4.7,17.17,17.17,0,0,1-1.3-6.8c0-5.2,1.9-9.4,5.8-12.4s9.1-4.5,15.7-4.5a50.41,50.41,0,0,1,9.6.9,43.8,43.8,0,0,1,6.9,1.8L311.09,30a26.37,26.37,0,0,0-5.6-1.8,36.69,36.69,0,0,0-7.8-.8,13.34,13.34,0,0,0-6.5,1.4,4.41,4.41,0,0,0-2.5,4.2,6.55,6.55,0,0,0,.5,2.5,5.21,5.21,0,0,0,1.7,2,27,27,0,0,0,3.2,1.9,40,40,0,0,0,4.8,1.9c3.1,1.2,5.8,2.3,8,3.4a20.66,20.66,0,0,1,5.4,3.8,12.41,12.41,0,0,1,3.1,4.8,18.13,18.13,0,0,1,1,6.5c0,5.5-2,9.6-6,12.4s-9.8,4.2-17.3,4.2a44.63,44.63,0,0,1-12.1-1.3,51.09,51.09,0,0,1-6.4-2l2.3-11a57.54,57.54,0,0,0,7,2.3A30.64,30.64,0,0,0,293,65.49Z",
    transform: "translate(-3.21 -2.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "sense-logo-cls-2",
    d: "M323.19,46.79a35.82,35.82,0,0,1,2.2-13.2,28.47,28.47,0,0,1,5.9-9.4,25.44,25.44,0,0,1,8.5-5.7,25.88,25.88,0,0,1,9.8-1.9c7.8,0,14,2.4,18.4,7.3s6.6,12.1,6.6,21.8a23.55,23.55,0,0,1-.1,2.5,19.48,19.48,0,0,1-.2,2.5h-37.6c.4,4.6,2,8.1,4.9,10.6s7,3.8,12.5,3.8a40.33,40.33,0,0,0,8.8-.9,34.52,34.52,0,0,0,6.3-1.9l1.7,10.8a16.23,16.23,0,0,1-3,1.1,35.25,35.25,0,0,1-4.4,1.1c-1.7.3-3.4.6-5.3.8a54.9,54.9,0,0,1-5.8.3,34.91,34.91,0,0,1-13.1-2.2,25.32,25.32,0,0,1-9.2-6.2,25,25,0,0,1-5.3-9.4A40.09,40.09,0,0,1,323.19,46.79Zm38.2-5.9a18.21,18.21,0,0,0-.8-5.2,14.54,14.54,0,0,0-2.2-4.3,11,11,0,0,0-3.6-2.8,11.32,11.32,0,0,0-5.1-1,12.53,12.53,0,0,0-5.3,1.1,14.49,14.49,0,0,0-3.9,3A13.14,13.14,0,0,0,338,36a20.65,20.65,0,0,0-1.2,4.9Z",
    transform: "translate(-3.21 -2.23)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_202",
    "data-name": "Ellipse 202",
    className: "sense-logo-cls-3",
    cx: 12.1,
    cy: 36.4,
    r: 12.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_205",
    "data-name": "Ellipse 205",
    className: "sense-logo-cls-4",
    cx: 48,
    cy: 12.1,
    r: 12.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_204",
    "data-name": "Ellipse 204",
    className: "sense-logo-cls-5",
    cx: 12.1,
    cy: 79.2,
    r: 12.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_206",
    "data-name": "Ellipse 206",
    className: "sense-logo-cls-6",
    cx: 48,
    cy: 55,
    r: 12.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSenseLogo);
export default __webpack_public_path__ + "static/media/sense-logo.3a3b3647b0696e28fef4fbb9b27ee349.svg";
export { ForwardRef as ReactComponent };